import axios from "../../lib/axiosInstance";

export function fetchUserNotifications(id) {
  return axios.get(`notifications`).then((res) => res.data);
}
export function fetchMessageNotifications(userId, cursor = null, limit = 10, type = null) {
  return axios
    .get(`notifications/messages`, { params: { userId, cursor, limit, type } })
    .then((res) => res.data);
}
export function fetchNotifications(userId, cursor = null, limit = 10, type = null) {
  return axios
    .get(`notifications/others`, { params: { userId, cursor, limit, type } })
    .then((res) => res.data);
}

export function markNotificationAsRead(id) {
  return axios.patch(`notifications/read/${id}`);
}

export function markNotificationAsReadAll(id) {
  return axios.patch(`notifications/readAll`);
}

export function markMessageNotificationAsReadAll() {
  return axios.patch(`notifications/messages/readAll`);
}

export function markAllMessagesAsReadByChatroom(chatroomId) {
  return axios.patch(`notifications/messages/readAll/${chatroomId}`);
}
